import React from 'react';
import HuntersBoard from '../components/HuntersBoard';
import PageWrapper from '../components/PageWrapper';
import { useSystemSettings } from '../lib/SystemSettingsContext';

const HuntersBoardPage: React.FC = () => {
  const { settings } = useSystemSettings();

  return (
    <PageWrapper title="Hunter's Board (Pentest Workspace)" showBackToDashboard={true}>
      {settings.disableHuntersBoard ? (
        <div className="text-center text-lg text-gray-500 py-12">Under development, check again later.</div>
      ) : (
        <HuntersBoard />
      )}
    </PageWrapper>
  );
};

export default HuntersBoardPage; 